<template>
  <div>
    <!-- 详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="editTitle"
      :visible.sync="defailDialogVisible"
      :before-close="defailHandleClose"
      width="40%"
      center
    >
      <el-divider></el-divider>
      <el-form class="editForm" label-width="110px" :model="editData">
        <div class="flexDis itemInp">
          <div>
            <el-form-item label="超级账号:">
              <el-input v-model="editData.account" disabled></el-input>
            </el-form-item>
          </div>
          <el-form-item label="分销商简称:">
            <span class="absPosiA">*</span>
            <el-input v-model="editData.abbreviation" :disabled="btndisa"></el-input>
          </el-form-item>
        </div>

        <el-form-item label="分销商全称:">
          <span class="absPosiB">*</span>
          <el-input v-model="editData.fullName" :disabled="btndisa"></el-input>
        </el-form-item>
        <!-- <el-form-item label="分销商类别:">
          <span class="absPosiC">*</span>
          <el-radio-group v-model="editData.fxsType" :disabled="btndisa">
            <el-radio label="1">一级分销商</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="第三方系统:">
            <div class="xitong">
              <el-select  :disabled="btndisa" @change="slectClick"   v-model="editData.third_system" placeholder="请选择分销商所使用的第三方系统">
                  <el-option
                    v-for="item in third"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value"
                  ></el-option>
              </el-select>
            </div>
        </el-form-item>
        <el-form-item label="地址:">
          <span class="absPosiD">*</span>
          <div class="flexDis itemSele">
            <div class="itemSeleOne">
              <!-- 省 -->
              <el-select
                v-model="editData.region1"
                placeholder="请选择省"
                @change="provinceChange($event)"
                :disabled="btndisa"
              >
                <el-option
                  v-for="item in cityProvince"
                  :key="item.provinceCode"
                  :label="item.provinceName"
                  :value="item.provinceCode"
                ></el-option>
              </el-select>
            </div>
            <div class="itemSeleOne">
              <!-- 市 -->
              <el-select
                v-model="editData.region2"
                placeholder="请选择市/区"
                @change="cityChange($event)"
                :disabled="btndisa"
              >
                <el-option
                  v-for="item in cityDistrict"
                  :key="item.cityCode"
                  :label="item.cityName"
                  :value="item.cityCode"
                ></el-option>
              </el-select>
            </div>
            <!-- 县 -->
            <el-select v-model="editData.region3" :disabled="btndisa" placeholder="请选择县/乡">
              <el-option
                v-for="item in cityCounty"
                :key="item.countyCode"
                :label="item.countyName"
                :value="item.countyCode"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="详细地址:">
          <span class="absPosiE">*</span>
          <el-input v-model="editData.address" :disabled="btndisa"></el-input>
        </el-form-item>
        <el-form-item label="联系人:">
          <span class="absPosiF">*</span>
          <el-input v-model="editData.contacts" :disabled="btndisa"></el-input>
        </el-form-item>
        <div class="flexDis itemMoble">
          <div>
            <el-form-item label="手机号:">
              <span class="absPosiG">*</span>
              <el-input v-model="editData.mobile" :disabled="btndisa"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="Email:">
            <span class="absPosiH">*</span>
            <el-input v-model="editData.email" :disabled="btndisa"></el-input>
          </el-form-item>
        </div>
        <div class="flexDis itemMoble">
          <div>
            <el-form-item label="余额:">
              <span class="absPosiI">*</span>
              <el-input v-model="editData.balance" :disabled="btndisa"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="透支金额:">
            <span class="absPosiJ">*</span>
            <el-input v-model="editData.overAmount" :disabled="btndisa"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="状态:">
          <span class="absPosiK">*</span>
          <el-radio-group v-model="editData.status" :disabled="btndisa">
            <el-radio label="1">上线</el-radio>
            <el-radio label="2">下线</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否发送短信:"  >
          <el-radio-group v-model="editData.sms_flag" :disabled="btndisa">
            <el-radio :label="1">发送</el-radio>
            <el-radio :label="2">不发送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款短信:" >
          <el-radio-group v-model="editData.refund_sms_flag" :disabled="btndisa">
            <el-radio :label="1">发送</el-radio>
            <el-radio :label="2">不发送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="itemBtn" v-if="btnType==2" style="margin-left:-110px">
          <el-button class="btnL" @click="editFn()">
            <i class="iconfont icon-tianxie cb"></i>编辑
          </el-button>
        </el-form-item>
        <el-form-item v-if="btnType==1" class="itemBtnS" style="margin-left:-110px">
          <el-button @click="cancleFn()">清空</el-button>
          <el-button class="btnL" @click="sureFn()">确认保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑详情弹框结束 -->
  </div>
</template>

<script>
import {
  getDistributorInfoPost,
  updateDistributorPost,
  addDistributorPost
} from "@/request/fxs.js";
import cityOptions from "@/assets/city.json";
import {Message} from 'element-ui'
export default {
  data() {
    return {
      defailDialogVisible: false, // 详情弹框
      // form表单绑定数据
      editData: {
        account: "", // 超级账号
        abbreviation: "", // 简称
        fullName: "", // 全称
        fxsType: "1", // 类别
        region1: "", // 省
        region2: "", // 市
        region3: "", // 县
        address: "", // 详细地址
        contacts: "", // 联系人
        mobile: "", // 手机号
        email: "", // email
        balance: "", // 余额
        overAmount: "", // 透支金额
        status: "", // 状态
        sms_flag:'1',
        refund_sms_flag:'1',
        third_system:''
      },
      // 编辑传参
      editPar: {
        token: "",
        distributor_id: "", // 分销商id
        E_Mail: "", // E_Mail
        Name: "", // 	分销商简称
        FullName: "", // 分销商全称
        Phone: "", // 电话
        ProID: "", // 省
        CityID: "", // 市
        ZoneID: "", // 	区县
        Address: "", // 地址
        LinkMan: "", // 	联系人
        Balance: "", // 余额
        AllMoney: "", // 透支金额
        UserName: "", // 	用户名
        Status: "", // 分销商状态
        Type: "", // 	分销商类型
        sms_flag:'1',
        refund_sms_flag:'1',
        third_system:''
      },
      third:[
        {
          value:'天时同城'
        },
        {
          value:'票付通'
        },
        {
          value:'自我游'
        },
        {
          value:'一机游'
        },
        {
          value:'九天达'
        },
        {
          value:'其他'
        }
      ],
      cityProvince: [],
      cityDistrict: [],
      cityCounty: [],
      distrbutorId: "",
      Token: "",
      account: "",
      editTitle: "", // 弹框标题
      btnType: "", // 详情和确认按钮区别
      flow:false,
      btndisa:false,
      retailFlow:true,
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
    this.cityProvince = cityOptions;
  },
  methods: {
    slectClick(e){
      if(e!='其他'){
          this.editData.refund_sms_flag = 2
          this.editData.sms_flag = 2
      }else{
        this.editData.refund_sms_flag = 1
        this.editData.sms_flag = 1
      }
    },
    // 随机超管账号
    randomLowerLetter(len) {
      const letters = "abcdefghijklmnopqrstuvwxyz";
      let res = "";
      for (let i = 0; i < len; i++) {
        var n = Math.round(Math.random() * letters.length);
        res += letters[n];
      }
      // console.log(res)
      this.account = res;
      console.log(this.editData.account);
      return res;
    },
    // 编辑确认
    sureFn() {
      if (this.distrbutorId) {
        console.log("编辑");
        // 编辑传参
        this.editPar = {
          token: this.Token,
          distributor_id: this.distrbutorId, // 分销商id
          E_Mail: this.editData.email, // E_Mail
          Name: this.editData.abbreviation, // 	分销商简称
          FullName: this.editData.fullName, // 分销商全称
          Phone: this.editData.mobile, // 电话
          ProID: this.editData.region1, // 省
          CityID: this.editData.region2, // 市
          ZoneID: this.editData.region3, // 	区县
          Address: this.editData.address, // 地址
          LinkMan: this.editData.contacts, // 	联系人
          Balance: this.editData.balance, // 	余额
          AllMoney: this.editData.overAmount, // 	透支金额
          UserName: this.editData.account, // 	用户名
          Status: this.editData.status + '', // 分销商状态
          Type: this.editData.fxsType, // 	分销商类型
          sms_flag:this.editData.sms_flag,
          refund_sms_flag:this.editData.refund_sms_flag ,
          third_system:this.editData.third_system
        };
        updateDistributorPost(this.editPar).then(res => {
          console.log(res);
          if (res.data.rcode == 200) {
            Message.success(res.data.msg);
            this.defailDialogVisible = false;
            let upData = {
              token: this.Token
            };
            this.$parent.getList(upData);
          } else {
            Message.error(res.data.msg);
          }
        });
      } else {
        console.log("添加");
        this.editPar = {
          token: this.Token,
          // distributor_id: this.distrbutorId, // 分销商id
          E_Mail: this.editData.email, // E_Mail
          Name: this.editData.abbreviation, // 	分销商简称
          FullName: this.editData.fullName, // 分销商全称
          Phone: this.editData.mobile, // 电话
          ProID: this.editData.region1, // 省
          CityID: this.editData.region2, // 市
          ZoneID: this.editData.region3, // 	区县
          Address: this.editData.address, // 地址
          LinkMan: this.editData.contacts, // 	联系人
          Balance: this.editData.balance, // 	余额
          AllMoney: this.editData.overAmount, // 	透支金额
          UserName: this.editData.account, // 	用户名
          Status: this.editData.status + '', // 分销商状态
          Type: this.editData.fxsType, // 	分销商类型
          sms_flag:this.editData.sms_flag,
          refund_sms_flag:this.editData.refund_sms_flag,
          third_system:this.editData.third_system
        };
        addDistributorPost(this.editPar).then(res => {
          if (res.data.rcode == 200) {
            Message.success(res.data.msg);
            this.defailDialogVisible = false;
            let upData = {
              token: this.Token
            };
            this.$parent.getList(upData);
          } else {
            Message.error(res.data.msg);
          }
        });
      }
    },
    // 编辑取消
    cancleFn() {
      // this.defailDialogVisible = false;
      this.editData={
        account: "", // 超级账号
        abbreviation: "", // 简称
        fullName: "", // 全称
        fxsType: "1", // 类别
        region1: "", // 省
        region2: "", // 市
        region3: "", // 县
        address: "", // 详细地址
        contacts: "", // 联系人
        mobile: "", // 手机号
        email: "", // email
        balance: "", // 余额
        overAmount: "", // 透支金额
        status: '1', // 状态
        sms_flag:1,
        refund_sms_flag:1,
        third_system:'其他'
      }
      if(this.editData.third_system!='其他'){
          this.retailFlow = false
          this.editData.refund_sms_flag = '2'
          this.editData.sms_flag = '2'
      }else{
        this.editData.refund_sms_flag = 1
        this.editData.sms_flag = 1
        this.retailFlow = true
        
      }
      this.$forceUpdate()
    },
    // 点击编辑
    editFn() {
      this.btndisa = false
      this.btnType = 1;
      this.editTitle = "一级分销商编辑";
    },
    // 选中省
    provinceChange(e) {
      console.log(e);
      this.cityProvince.forEach((item, index) => {
        if (e == item.provinceCode) {
          this.cityDistrict = item.cities;
          this.editData.region2 = "";
          this.editData.region3 = "";
        }
      });
    },
    // 选中市
    cityChange(e) {
      this.cityDistrict.forEach((item, index) => {
        if (e == item.cityCode) {
          this.cityCounty = item.counties;
          this.editData.region3 = "";
        }
      });
    },
    // 详情弹框
    defail(row) {
      if (row) {
        this.flow = true
        this.btndisa = true
        this.distrbutorId = row.DistributorID;
        this.btnType = 2;
        this.editTitle = "一级分销商详情";
        let upData = {
          distributor_id: row.DistributorID
        };
        getDistributorInfoPost(upData).then(res => {
          this.editData = {
            account: res.data.result.user_name, // 超级账号
            abbreviation: res.data.result.Name, // 简称
            fullName: res.data.result.FullName, // 全称
            fxsType: res.data.result.Type, // 类别
            region1: String(res.data.result.ProID), // 省
            region2: String(res.data.result.CityID), // 市
            region3: String(res.data.result.ZoneID), // 县
            address: res.data.result.Address, // 详细地址
            contacts: res.data.result.LinkMan, // 联系人
            mobile: res.data.result.Phone, // 手机号
            email: res.data.result.E_Mail, // email
            balance: res.data.result.Balance, // 余额
            overAmount: res.data.result.OverDraftMoney, // 透支金额
            status: res.data.result.Status + '', // 状态
            sms_flag: res.data.result.sms_flag , 
            refund_sms_flag: res.data.result.refund_sms_flag , 
            third_system:res.data.result.third_system
          };
          if(this.editData.third_system!='其他'){
              this.retailFlow = false
          }else{
            this.editData.third_system = '其他'
            this.retailFlow = true
          }
          // 省赋值后获取市下拉框对应的值
          this.cityProvince.map((item, index) => {
            if (item.provinceCode == res.data.result.ProID) {
              this.cityDistrict = item.cities;
            }
          });
          // 市赋值后获取县下拉框对应的值
          this.cityDistrict.map((item, index) => {
            if (item.cityCode == res.data.result.CityID) {
              this.cityCounty = item.counties;
            }
          });
        });
      } else {
        this.distrbutorId  = ''
        this.btndisa = false
        this.flow = false
        console.log("添加");
        this.btnType = 1;
        this.editTitle = "添加分销商";
        this.randomLowerLetter(10);
        // 初始化数据
        this.editData = {
          account: this.account, // 超级账号
          abbreviation: "", // 简称
          fullName: "", // 全称
          fxsType: "1", // 类别
          region1: "", // 省
          region2: "", // 市
          region3: "", // 县
          address: "", // 详细地址
          contacts: "", // 联系人
          mobile: "", // 手机号
          email: "", // email
          balance: "", // 余额
          overAmount: "", // 透支金额
          status: "1", // 状态
          sms_flag:1,
          refund_sms_flag:1,
          third_system:'其他'
        };
        if(this.editData.third_system!='其他'){
            this.retailFlow = false
            this.editData.refund_sms_flag = '2'
            this.editData.sms_flag = '2'
        }else{
          this.retailFlow = true
          this.editData.refund_sms_flag = 1
          this.editData.sms_flag = 1
        }
      }

      this.defailDialogVisible = true;
    },
    // 详情X
    defailHandleClose() {
      this.defailDialogVisible = false;
    }
  }
};
</script>

<style lang='less' scoped>
.editForm {
  /deep/.el-form-item {
    position: relative;
  }
  .absPosiA {
    position: absolute;
    top: 0px;
    left: -94px;
    color: red;

  }
  .absPosiB,
  .absPosiC {
    position: absolute;
    top: 0px;
    left: -94px;
    color: red;
  }
  .absPosiE {
    position: absolute;
    top: 0px;
    left: -80px;
    color: red;

  }
  .absPosiF {
    position: absolute;
    top: 0px;
    left: -65px;
    color: red;

  }
  .absPosiG,
  .absPosiH {
    position: absolute;
    top: 0px;
    left: -65px;
    color: red;

  }
  .absPosiI {
    position: absolute;
    top: 0px;
    left: -50px;
    color: red;

  }
  .absPosiD {
    position: absolute;
    top: 0px;
    left: -50px;
    color: red;

  }
  .absPosiJ {
    position: absolute;
    top: 0px;
    left: -80px;
    color: red;

  }
  .absPosiK {
    position: absolute;
    top: 0px;
    left: -52px;
    color: red;

  }
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333333;

  .itemBtnS {
    display: flex;
    justify-content: center;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    /deep/.el-form-item__content {
      margin-left: 0px;
    }
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #246deb;
    }
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .itemSele {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .itemSeleOne {
      margin-right: 23px;
    }
    .el-select {
      width: 190px;
    }
  }
  .itemMoble {
    display: flex;
    flex-wrap: wrap;
    > div:nth-child(1) {
      .el-form-item {
        margin-right: 27px;
      }
    }
    /deep/.el-input {
      width: 240px;
    }
  }

  .itemInp {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    > div:nth-child(1) {
      .el-form-item {
        margin-right: 20px;
      }
    }
    .el-input {
      width: 243px;
    }
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/ .el-form-item__content input{
  background: #ffffff !important;
}
/deep/ .el-input.is-disabled .el-input__inner{
  color: #000 !important;
}
.xitong{
  ::v-deep .el-select{
    width: 100%;
  }
}
::v-deep .el-radio__label{
  color: #000 !important;
}
</style>